export function resolveBookingCaseTypeLabel(record = {}) {
  const customCaseType = String(record?.customCaseType || record?.custom_case_type || "").trim();
  if (customCaseType) return customCaseType;

  const caseType = String(record?.caseType || record?.case_type || "").trim();
  return caseType || "Legal Consultation";
}